// extracted by mini-css-extract-plugin
module.exports = {"idText":"EphemeralId_idText__335Fg"};